import { list, ListPaginateWithPathOutput, remove, getUrl } from 'aws-amplify/storage';

export default class StorageUtils {

    public static readonly PHOTO_STORAGE_BUCKET_NAME: string = "photoStorageBucket"

    public static readonly PLACE_PHOTOS: string = "placePhotos"
    public static readonly REMOVED_PLACE_PHOTOS: string = "removedPlacePhotos"
    public static readonly PROFILE_PICTURES: string = "profilePictures"
    public static readonly REMOVED_PROFILE_PICTURES: string = "removedProfilePictures"

    public static readonly PLACE_PHOTOS_MAIN_IMAGE_PREFIX: string = "main_image_"

    // File metadata keys
    public static readonly UPLOADER_USER_ID_METADATA_KEY: string = "uploaderUserId"
    public static readonly ORIGINAL_FILE_NAME_METADATA_KEY: string = "originalFileName"

    // TODO good idea on file upload, to avoid duplicates https://ui.docs.amplify.aws/react/connected-components/storage/fileuploader#pre-upload-processing

    public static async deletePlaceImageFile(placeId: string, imageFileName: string): Promise<void> {
        return this.deleteFile(`${this.PLACE_PHOTOS}/${placeId}/${imageFileName}`)
    }

    public static async deleteFile(filePath: string): Promise<void> {
        try {
            await remove({
                path: filePath
            });
            console.info(`Successfully deleted file: ${filePath}`);
        } catch (error) {
            console.error(`Failed to delete file ${filePath}:`, error);
            throw error;
        }
    }

    public static async getPlaceImagesFiles(placeId: string): Promise<ListPaginateWithPathOutput> {
        const path = `${this.PLACE_PHOTOS}/${placeId}`
        const result = await list({
            path: path
        });

        return result;
    }

    public static async getPlaceMainImagePath(placeId: string): Promise<string | null> {
        try {
            const path = `${this.PLACE_PHOTOS}/${placeId}/${this.PLACE_PHOTOS_MAIN_IMAGE_PREFIX}`
            const result = await list({
                path: path,
                options: {
                    // We only need one result
                    pageSize: 1
                }
            });

            // Return the first matching file path or null
            return result.items[0]?.path || null;
        } catch (error) {
            console.error(`Failed to get main image for place ${placeId}:`, error);
            return null;
        }
    }

    public static async getImageUrl(path: string): Promise<string | null> {
        try {
            const result = await getUrl({
                path: path,
                options: {
                    // Use signed URL for security
                    useAccelerateEndpoint: false
                }
            });
            return result.url.toString();
        } catch (error) {
            console.error(`Failed to get URL for image ${path}:`, error);
            return null;
        }
    }
}